import React from "react";
import StackTrace from "stacktrace-js";
import axios from "axios";
import { detect } from "detect-browser";
import { getUserToken } from "../lib/UserToken";

export default class ErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    const url = (
      window.HYRO_WIDGET_SERVER_URL || process.env.REACT_APP_SOCKET_SERVER
    ).replace("ws", "http");
    const errorMessage = error.message;
    StackTrace.fromError(error).then((stackTrace) => {
      axios.post(
        `${url}/client-error`,
        {
          errorMessage,
          stackTrace,
          errorInfo,
          roomId: window.HYRO_WIDGET_ID || window.WIDGET_ID,
          deviceInfo: detect(),
          token: getUserToken(),
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    });
  }

  render() {
    return this.props.children;
  }
}
